import { render, staticRenderFns } from "./salesReceivingList.vue?vue&type=template&id=e8902246&scoped=true"
import script from "./salesReceivingList.vue?vue&type=script&lang=js"
export * from "./salesReceivingList.vue?vue&type=script&lang=js"
import style0 from "./salesReceivingList.vue?vue&type=style&index=0&id=e8902246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8902246",
  null
  
)

export default component.exports